<template>
    <div>
        <b-form-group :label="label" :class="{'no-margin-bottom': noMarginBottom}" style="text-align: initial !important;" :label-for="id" :description="description">
        <div>
                <b-form-timepicker v-model="localValue" :placeholder="placeholder" :label-close-button="$t('close')" :label-decrement="$t('time-picker.decrement')" :label-increment="$t('time-picker.increment')" :reset-button="resetButton"
                :label-hours="$t('hours')" :label-minutes="$t('minutes')" :label-seconds="$t('seconds')" :label-no-time-selected="$t('time-picker.no-time-selected')" :label-now-button="$t('time-picker.current-time')" dropup
                :label-reset-button="$t('time-picker.reset-btn')" :locale="$i18nHelpers.getNormalizedLocale()" :show-seconds="showSeconds" close-button-variant="secondary" :now-button="nowButton" @input="$emit('input', $event)"></b-form-timepicker>
        </div>
      </b-form-group>
    </div>
  </template>
  
  <script>
  import { BFormTimepicker, BFormGroup } from 'bootstrap-vue'
  import wrapperMixin from '@/mixins/wrapper.mixin'

  const messages = {
        es: {
            'time-picker.select-hour': 'Seleccione una hora',
            'time-picker.decrement': 'Disminuir',
            'time-picker.increment': 'Aumentar',
            'time-picker.no-time-selected': 'Hora no seleccionada',
            'time-picker.current-time': 'hora actual',
            'time-picker.reset-btn': 'Resetear'
        },
        en: {
            'time-picker.select-hour': 'Select a time',
            'time-picker.decrement': 'Decrease',
            'time-picker.increment': 'Increase',
            'time-picker.no-time-selected': 'Hour not selected',
            'time-picker.current-time': 'Current time',
            'time-picker.reset-btn': 'Reset'
        },
        pt: {
            'time-picker.select-hour': 'Selecione um horário',
            'time-picker.decrement': 'Decremento',
            'time-picker.increment': 'Incremento',
            'time-picker.no-time-selected': 'Hora não selecionada',
            'time-picker.current-time': 'Hora atual',
            'time-picker.reset-btn': 'Redefinir'
        }
    }

  export default {
    mixins: [wrapperMixin(String)],
    i18n: {
		messages
	},
    components: {
        BFormTimepicker,
        BFormGroup
    },
    props: {
        showSeconds: Boolean,
        resetButtton: Boolean,
        noMarginBottom: Boolean,
        label: {
            type: String,
            required: false,
            default: ''
        },
        description: {
            type: String,
            required: false,
            default: ''
        },
        resetButton: {
            type: Boolean,
            default: true
        },
        nowButton: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default () {
                return this.$t('time-picker.selectHour')
            }
        }
    },
    data () {
      return {
      }
    },
    mounted () {
    },
    created () {
    },
    methods: {
    }
  }
  </script>
  
  <style lang="scss" scoped>
  </style>


// WEBPACK FOOTER //
// src/components/base/forms/BaseTimepicker.vue